import _ from 'lodash';
import type { DeletedStudyQuery, DeletedStudyQueryVariables } from '@/shared/api';

import { createClient } from '@/shared/api';
import DELETED_STUDY_QUERY from '../queries/deletedStudy';

/**
 * Loads the patient information of a deleted study. Runs DELETED_STUDY_QUERY, throws the first GraphQL error message when deletedStudy is nil, and hands back the whole Apollo result rather than the study field.
 *
 * @param id - Identifier of the deleted study.
 * @returns The raw Apollo query result holding the deleted study.
 */
const fetchDeletedStudyPatientInfo = async (id: any) => {
  const client = createClient();
  const deletedStudyResult = await client.query<DeletedStudyQuery, DeletedStudyQueryVariables>({
    query: DELETED_STUDY_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = deletedStudyResult;
  const { deletedStudy } = data;
  if (_.isNil(deletedStudy) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return deletedStudyResult;
};

export default fetchDeletedStudyPatientInfo;
